import reactivate from '../Services/reactivate'

export default () => (dispatch) => {
  
  dispatch(reactivate())

}
